.chart {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.titleRow {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 8px;
}

.title {
  margin: 0;
  color: var(--text-primary);
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
}

.grid {
  stroke: var(--dark-border);
  stroke-width: 1;
}

.axisLabel {
  fill: var(--text-tertiary);
  font-size: 10px;
  font-weight: 600;
}

.titleGroup {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 12px;
}

.missing {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--text-secondary);
  font-size: 12px;
  line-height: 16px;
}

.missingSwatch {
  width: 8px;
  height: 8px;
  opacity: 0.3;
}

.plot {
  position: relative;
}

.plot svg {
  touch-action: pan-y pinch-zoom;
}

.overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  font-size: 12px;
}

.faded {
  opacity: 0.3;
}

.bound {
  stroke: var(--text-primary);
  stroke-width: 1;
}

.notLoaded rect {
  fill: var(--gray-500);
}

.notLoaded text {
  fill: var(--text-tertiary);
  font-size: 12px;
  font-weight: 600;
}

.titleNote {
  color: var(--text-secondary);
  font-size: 12px;
  line-height: 16px;
}

.originLabels {
  position: relative;
  height: 16px;
}

.originLabel {
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  color: var(--text-tertiary);
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
}

.origin {
  stroke: var(--gray-400);
  stroke-width: 1;
  stroke-dasharray: 4 4;
}

.zoomed {
  cursor: zoom-out;
  user-select: none;
}

.crosshair {
  stroke: var(--text-primary);
  stroke-width: 1;
  pointer-events: none;
}

.event,
.eventActive {
  stroke: var(--gray-400);
  pointer-events: none;
}

.event {
  stroke-width: 1;
}

.eventActive {
  stroke: var(--text-secondary);
  stroke-width: 2.5;
}
